<template>
  <nav class="menu-logado menu-b2b-20" style="line-height:1">
    <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" clipped :permanent="!$vuetify.breakpoint.xsOnly" app v-if="exibeSidebar">
      <v-list>
        <div v-for="(link, i) in itens" :key="i">
          <v-list-item v-if="!link.subLinks && link.show" :key="i" @click="abreLink(link, 1)" :class="classItem(link.url)" :title="mini ? link.title : false">
            <v-list-item class="v-list-item">
              <v-list-item-icon>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ link.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
          <v-list-group v-else-if="link.show" :key="link.text" no-action @click="redirect(link.title)" :class="classGroupItem(link.title)" :title="mini ? link.title : false">
            <template v-slot:activator>
              <v-list-item class="v-list-item">
                <v-list-item-icon>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ link.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <div v-for="(sublink, index) in link.subLinks">
              <v-list-item v-if="sublink.show != false" @click="abreLink(sublink, index)" :key="sublink.title" :id="sublink.title" :class="classItemSublink(index, sublink)">
                <v-list-item-title v-text="sublink.title" />
              </v-list-item>
            </div>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar clipped-left app>
      <v-app-bar-nav-icon @click="alternaDrawer()">
        <v-icon v-if="icon && exibeSidebar" :style="{ color: colorBurger}" class="burger">mdi-forwardburger</v-icon>
        <v-icon v-if="!icon && exibeSidebar" :style="{ color: colorBurger}" class="burger">mdi-backburger</v-icon>
        <a v-if="!exibeSidebar" @click="$router.push('/home')"><v-icon>mdi-arrow-left</v-icon></a>
      </v-app-bar-nav-icon>
    
      <menu-dropdown-cursos-b2b-20 :categorias="categorias"></menu-dropdown-cursos-b2b-20>

      <ul class="nav nav-fill align-items-center">
        <li class="nav-item order-1 order-md-1 nav-logo">
          <a class="navbar-brand" @click="redirectTo('/home')">
            <img :src="logoUrl" :alt="logo.texto" class="img-fluid img-logo" v-if="logoUrl">
            <img :src="logoDarkUrl" :alt="logo.texto" class="img-fluid img-logo-dark" v-if="logoDarkUrl">
            <template v-else>{{ logo.texto }}</template>
          </a>
        </li>
        <li v-if="exibirBarraBuscaHeader" class="nav-item search-menu order-2 order-md-2">
          <form>
            <div class="search">
              <input type="text" class="search-term" placeholder="O que você procura?" v-model="termoPesquisa">
              <button type="submit" class="searchButton" @click="buscaGeralPlataforma">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </form>
        </li>
        <li class="nav-item user-menu-notif order-5 order-md-5">
            <div>
          <b-dropdown class="search-menu-mobile" no-caret right>
            <template slot="button-content">
                <i class="fa fa-search"></i>
            </template>
            <form>
              <div class="search">
                <input type="text" class="search-term" placeholder="O que você procura?" v-model="termoPesquisa">
                <a type="submit" class="searchButton" @click="buscaGeralPlataforma">
                  <i class="fa fa-search"></i>
                </a>
              </div>
            </form>
          </b-dropdown>
          </div>
          <slot></slot>
        <div class="user-menu order-2 order-md-7">
          <b-nav-item-dropdown no-caret class="menu-usuario-logado" right>
            <template slot="button-content">
              <a class="nav-link" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img :src="avatar" @error="imgReplaceByDefault"></a>
            </template>
            <div class="d-flex nome-email align-items-center">
              <div>
                <p>{{ usuario.name }}</p>
                <p>{{ usuario.email }}</p>
              </div>
            </div>
            <hr />
            <b-dropdown-item v-if="temPermissaoAdmin && acessosEmpresa.temAcesso(tiposAcesso.SSO_PROFESSORES_JALEKO.nome, configEmpresa.rotasRestritasAcesso)" @click="redirectToWL()"><i class="fas fa-chalkboard-teacher"></i>Professores de Jaleko</b-dropdown-item>
            <b-dropdown-item @click="redirectTo('/perfil/meus-dados')"><i class="fas fa-user"></i> Meus dados</b-dropdown-item>
            <b-dropdown-item @click="redirectTo('/perfil/minhas-duvidas')" v-if="false"><i class="fas fa-hands-helping"></i> Minhas dúvidas</b-dropdown-item>
            <b-dropdown-item @click="redirectTo('/perfil/problemas')" v-if="false"><i class="fas fa-bug"></i> Problemas que relatei</b-dropdown-item>
            <b-dropdown-item @click="redirectTo('/perfil/cadernos')"><i class="fas fa-book"></i> Meus cadernos</b-dropdown-item>
            <b-dropdown-item @click="redirectTo('/perfil/meus-tutores')" v-if="acessosEmpresa.temAcesso(tiposAcesso.PERFIL_MEUS_TUTORES.nome, configEmpresa.rotasRestritasAcesso)"><i class="fas fa-chalkboard-teacher"></i> Tutor(a)</b-dropdown-item>
            <b-dropdown-item @click="redirectTo('/ajuda/faq')"><i class="fas fa-question-circle"></i> Ajuda</b-dropdown-item>
            <b-dropdown-item @click="redirectTo('/contato')"><i class="fas fa-comments"></i> Entre em contato</b-dropdown-item>
            <b-dropdown-item href="javascript:void(0)" @click="alternarDarkMode">
              <i class="fas fa-moon"></i>
              {{ modoNoturno ? "Sair do modo noturno" : "Modo noturno" }}
              <span class="aviso-novo">Novo</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="temPermissaoAdmin" @click="redirectToCms()"><i class="fas fa-user-cog"></i>Plataforma Admin</b-dropdown-item>
            <b-dropdown-item @click="logout()" class="link-logout"><i class="fas fa-sign-out-alt"></i> Sair</b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
        </li>
      </ul>
    </v-app-bar>
  </nav>
</template>

<script>
import MenuDropdownCursosB2b20 from './menu-dropdown-cursos-b2b-20'
import './scss/vue-header-b2b.scss'

export default {
  name: 'HeaderB2b20',
  components:{
    MenuDropdownCursosB2b20
  },
  props: {
    categorias: Array,
    logo: Object,
    logoUrl: String,
    logoDarkUrl: String,
    acessosEmpresa: Object,
    tiposAcesso: Object,
    configEmpresa: Object,
    t: Function,
    router: Object,
    route: Object,
    exibirBarraBuscaHeader: Boolean,
    avatar: String,
    avatarPadrao: String,
    usuario: Object,
    temPermissaoAdmin: Boolean,
    modoNoturno: Boolean
  },
  data () {
    return {
      termoPesquisa: '',
      exibeMenuCurso: false,
      drawer: false,
      categoriaSelecionada: null,
      catExcluidasCurso: ['Eventos', 'Projetos no Youtube', 'Ferramentas de Aprendizagem'],
      catExcluidasAoVivo: ['Eventos', 'Projetos no Youtube'],
      exibeSidebar: true,
      subLinkSelecionado: null
    }
  },
  created () {
    this.menuBackgroundColor = this.configEmpresa.menuBackgroundColor ? this.configEmpresa.menuBackgroundColor : '#363953'
  },
  mounted () {
    this.$root.$on('menuCursosFechado', () => {
      this.categoriaSelecionada = ''
    })
    this.$nextTick(() => {
      if(!this.$vuetify.breakpoint.xsOnly) {
        this.drawer = (localStorage.drawer === 'true')
      }
    })
  },
  computed: {
    itens: function () {
      return [
        {
          show: true,
          title: 'Início',
          icon: 'mdi-home',
          url: '/home'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_CURSOS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Cursos',
          icon: 'mdi-book-outline',
          subLinks: this.catCursos
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_FERRAMENTAS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Ferramentas',
          icon: 'mdi-puzzle',
          subLinks: [
            {
              show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_FLASHCARDS.nome, this.configEmpresa.rotasRestritasAcesso),
              title: 'Flashcards',
              url: '/flashcards'
            },
            {
              show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_SIMULADOS.nome, this.configEmpresa.rotasRestritasAcesso),
              title: this.configEmpresa.textosConfiguraveis.textoDisplaySimulados,
              url: '/simulados'
            },
            {
              title: 'Resumos',
              ref: 'resumos',
            },
            {
              title: 'Modelos 3D',
              ref: 'modelos-3d'
            },
            {
              title: 'Mapas Mentais',
              ref: 'mapas-mentais',
            },
            {
              title: 'Ver todas',
              ref: 'todas',
              url: '/ferramentas'
            }
          ]
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_JALEKLINICO.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Jaleklínico',
          icon: 'mdi-robot-happy',
          url: '/jaleklinico'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_ARTIGOS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: this.t('artigos'),
          href: 'https://blog.jaleko.com.br/',
          icon: 'mdi-newspaper-variant-outline'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_BIBLIOTECA_A.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Biblioteca A',
          icon: 'mdi-bookshelf'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_ARTMED360.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Artmed360',
          url: '/artmed360',
          icon: 'mdi-plus-outline'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_GRUPO_VITA_PART.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Grupo Vita Part',
          href: 'https://vitapart.com.br/',
          icon: 'mdi-water'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_LIVES.nome, this.configEmpresa.rotasRestritasAcesso),
          title: this.configEmpresa.textosConfiguraveis.textoDisplayLives,
          url: '/lives',
          icon: 'mdi-access-point',
        },
      ]
    },
    catCursos: function () {
      return (this.categorias.filter(categoria => {
        return !this.catExcluidasCurso.includes(categoria.title) }));
    },
    mini () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return false
      } else {
        if (this.drawer) {
          return true
        } else {
          return false
        }
      }
    },
    icon () {
      if (this.$vuetify.breakpoint.xsOnly) {
        if (this.drawer) {
          return false
        } else {
          return true
        }
      } else {
        if (this.drawer) {
          return true
        } else {
          return false
        }
      }
    },
    noActionListGroup () {
      if (this.drawer) {
        return true
      } else {
        return false
      }
    },
    mobile () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    drawer() {
      this.$root.$emit('drawer', this.drawer)
    },

    '$route.params': function () {
      if (window.location.href.indexOf('/sala-de-aula') > -1) {
        this.exibeSidebar = false
      } else {
        this.exibeSidebar = true
      }
    }
  },
  methods: {
    imgReplaceByDefault: function (event) {
      event.target.src = this.avatarPadrao
    },
    buscaGeralPlataforma: function (event) {
      event.preventDefault()

      this.$emit('buscaGeralPlataforma', this.termoPesquisa)
    },
    exibeMenu () {
      this.exibeMenuCurso = !this.exibeMenuCurso
    },
    ocultarMenu () {
      this.exibeMenuCurso = false
    },
    SSOBibliotecaA: function () {
      this.$emit('SSOBibliotecaA')
    },
    logout: function () {
      this.$emit('logout')
    },
    redirectToWL: function () {
      this.$emit('redirectToWL')
    },
    redirectToCms: function () {
      this.$emit('redirectToCms')
    },
    alternarDarkMode: function () {
      this.$emit('alternarDarkMode')
    },
    redirectTo: function (path) {
      if (this.router) {
        this.router.push(path);
      } else {
        window.location = path;
      }
    },
    redirect (title) {
      if (this.drawer && this.mini) {
        switch (title) {
          case 'Cursos':
            this.$router.push('/cursos')
            break
          case 'Ferramentas':
            this.$router.push('/ferramentas')
            break
          default:
            return ''
        }
      }
    },
    abreLink (sublink, index) {
      if (typeof sublink.disciplinas !== 'undefined' && !this.mobile) {
        let payload = {
          categoria: sublink,
          index: index
        }
        this.$root.$emit('categoriaSelecionada', payload)
        this.categoriaSelecionada = index
      } else {
        switch (sublink.title) {
          case 'Início':
            this.$router.push(sublink.url)
            break
          case 'Flashcards':
            window.location = sublink.url
            break
          case this.configEmpresa.textosConfiguraveis.textoDisplaySimulados:
            this.subLinkSelecionado = index
            this.$router.push(sublink.url)
            break
          case 'Modelos 3D':
            this.subLinkSelecionado = index
            this.$store.dispatch('alternaFerramenta', sublink.ref)
            this.$router.push({
              name: 'ferramentas',
              params: { 
                ferramentaAtiva: sublink.ref,
                nomeAtivo: sublink.title
              }
            })
            break
          case 'Mapas Mentais':
            this.subLinkSelecionado = index
            this.$store.dispatch('alternaFerramenta', sublink.ref)
            this.$router.push({
              name: 'ferramentas',
              params: { 
                ferramentaAtiva: sublink.ref,
                nomeAtivo: sublink.title
              }
            })
            break
          case 'Resumos':
            this.subLinkSelecionado = index
            this.$store.dispatch('alternaFerramenta', sublink.ref)
            this.$router.push({
              name: 'ferramentas',
              params: { 
                ferramentaAtiva: sublink.ref,
                nomeAtivo: sublink.title
              }
            })
            break
          case 'Ver todas':
            this.subLinkSelecionado = index
            this.$store.dispatch('alternaFerramenta', sublink.ref)
            this.$router.push(sublink.url)
            break
          case 'Jaleklínico':
            window.location = sublink.url
            break
          case 'Artigos':
            window.open(sublink.href, '_blank') 
            break
          case 'Biblioteca A':
            this.SSOBibliotecaA()
            break
          case 'Artmed360':
            this.$router.push(sublink.url)
            break
          case 'Grupo Vita Part':
            window.open(sublink.href, '_blank') 
            break
          case this.configEmpresa.textosConfiguraveis.textoDisplayLives:
            this.$router.push(sublink.url)
            break
          default:
            return ''
        }
      }
    },
    classItem: function (url) {
      if (this.$router.currentRoute.path === url) {
        this.subLinkSelecionado = null
        return 'v-list-item highlighted'
      }
      return 'v-list-item'
    },
    classGroupItem: function (title) {
      switch (title) {
        case 'Cursos':
          if (this.$router.currentRoute.path.includes('/cursos')) {
            return 'highlighted'
          }
          break
        case 'Ferramentas':
          if (this.$router.currentRoute.path === '/ferramentas' || this.$router.currentRoute.path === '/flashcards') {
            return 'highlighted'
          }
          break
        default:
          return ''
      }
    },
    classItemSublink: function (index, sublink) {
      if (index === this.subLinkSelecionado) {
        this.categoriaSelecionada = null
        return 'v-list-item highlighted'
      } else if (index === this.categoriaSelecionada && sublink.disciplinas) {
        this.subLinkSelecionado = null
        return 'v-list-item highlighted'
      } else {
        return 'v-list-item'
      }
    },
    alternaDrawer() {
      this.drawer = !this.drawer
      localStorage.drawer = this.drawer
    },
    colorBurger () {
      if (this.modoNoturno) {
        return 'white'
      }
    }
  }
}
</script>

<style lang="css" src="vuetify/dist/vuetify.min.css">
</style>